<ftr-inline-input
  class="case-reference"
  placeholder="Case Reference"
  [hasError]="hasError('caseReference')"
  [value]="value().caseReference ?? ''"
  [readonly]="readOnly()"
  (valueChange)="onChange({ caseReference: $event })"
  [upperCase]="true"
  #caseReferenceInput
></ftr-inline-input>
<div class="case-title">
  <ftr-inline-input
    placeholder="Case Title"
    size="large"
    [hasError]="hasError('recordedCaseTitle')"
    [value]="value().recordedCaseTitle ?? ''"
    [readonly]="readOnly()"
    (valueChange)="onChange({ recordedCaseTitle: $event })"
  ></ftr-inline-input>
</div>
<div class="times">
  <span class="time-input-container" [ngClass]="{ 'has-error': hasError('startTime') }">
    <ftr-inline-input
      [value]="this.uiHearingSectionModel().startTime"
      label="Start Time"
      [hasError]="hasError('startTime')"
      [readonly]="readOnly()"
      (valueChange)="onChange({ startTime: $event })"
      [placeholder]="timeInputPlaceholder"
    ></ftr-inline-input>
  </span>
  <span class="separator">-</span>
  <span class="time-input-container" [ngClass]="{ 'has-error': hasError('endTime') }">
    <ftr-inline-input
      [value]="this.uiHearingSectionModel().endTime"
      [hasError]="hasError('endTime')"
      (valueChange)="onChange({ endTime: $event })"
      [readonly]="readOnly()"
      label="End Time"
      [unfocusedText]="value().showAsOngoing ? 'Ongoing' : undefined"
      (onFocus)="endTimeInputFocused.set(true)"
      (onBlur)="handleEndTimeInputBlur()"
      [placeholder]="timeInputPlaceholder"
    ></ftr-inline-input>

    @if (endTimeMenuIsOpen()) {
      <div class="menu">
        <button
          class="menu-item"
          (focus)="endTimeMenuFocused.set(true)"
          (blur)="endTimeMenuFocused.set(false)"
          (click)="handleSetToOngoing()"
        >
          <ftr-icon icon="Schedule" size="Small" class="icon" />
          <span>Set to Ongoing</span>
        </button>
      </div>
    }
  </span>
</div>

@if (!readOnly()) {
  <button (click)="openModal(deleteModal)" class="delete-button">
    <ftr-icon icon="Delete" color="Grey30" [interactive]="true"></ftr-icon>
  </button>
  <ftr-inline-save-status [state]="status()" (retry)="retry$.next()" (undo)="onUndo()"></ftr-inline-save-status>
}
<ng-template #deleteModal>
  <ftr-delete-hearing-annotation-modal (onDelete)="onHearingDeleted.emit()"></ftr-delete-hearing-annotation-modal>
</ng-template>
